/* eslint-disable max-len */
/**
 * 这个只是给 TypeScript 用的，将 ES5 风格的构造函数变成 ES6 类构造函数
 */
export const CastConstructor = ctor => ctor;
/**
 * 用来创建一个 DataClass 的 Constructor
 */
export const createDataClass = () => CastConstructor(function (data) {
  Object.assign(this, data);
});